module.exports = __webpack_public_path__ + "img/pocket button diameter.5164d9ba.png";